import { BookingAdmin, BookingStatus } from '@/types';
import { Typography } from 'antd';
import { format } from 'date-fns';

interface Props {
  booking: BookingAdmin;
}

export default function BookingDetailed({ booking }: Props) {
  if (!booking) return null;

  const statusColors = {
    pending: '#FFA500',
    declined: '#F68B8B',
    completed: '#1C8271',
    future: '#2A4BC2',
  };

  const formatDate = (date?: Date) =>
    date ? format(new Date(date), 'd MMM, yyyy, h:mm a') : '-';

  const formatStatus = (status: string) =>
    status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <div className="detailed-wrapper" style={{ flex: 1 }}>
      <div className="detailed-content">
        <Typography.Title level={3} style={{ margin: '0 0 24px' }}>
          General Info
        </Typography.Title>
        <div className="details-section-column">
          <InfoLine label="ID" value={booking._id || '-'} />
          <div className="details-section-line">
            <Typography.Text className="general-info-text">
              Status
            </Typography.Text>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: statusColors[booking.status],
                }}
              />
              <Typography.Text>{formatStatus(booking.status)}</Typography.Text>
            </div>
          </div>

          <InfoLine
            label="Duration"
            value={booking.duration.toString() || '-'}
          />
        </div>
      </div>
      <div className="detailed-content">
        <div className="details-section-column">
          <InfoLine
            label="Meeting Booked"
            value={formatDate(booking.createdAt)}
          />
          <InfoLine label="Meeting Started" value={formatDate(booking.start)} />
          <InfoLine
            label="Mark as Completed"
            value={
              booking.status === BookingStatus.COMPLETED
                ? formatDate(booking.markedAsCompletedAt)
                : 'N/A'
            }
          />
        </div>
      </div>
      <div className="detailed-content">
        <div className="details-section-column">
          <InfoLine label="Total" value={booking.paidAmount.toString()} />
          <InfoLine label="IsPaid" value={booking.isPaid ? 'Yes' : 'No'} />
        </div>
      </div>
    </div>
  );
}

function InfoLine({ label, value }: { label: string; value: string }) {
  return (
    <div className="details-section-line">
      <Typography.Text className="general-info-text">{label}</Typography.Text>
      <Typography.Text className="general-info-value">{value}</Typography.Text>
    </div>
  );
}
